import { render, staticRenderFns } from "./PersonalAdd.vue?vue&type=template&id=fc66f95e&scoped=true"
import script from "./PersonalAdd.vue?vue&type=script&lang=js"
export * from "./PersonalAdd.vue?vue&type=script&lang=js"
import style0 from "./PersonalAdd.vue?vue&type=style&index=0&id=fc66f95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc66f95e",
  null
  
)

export default component.exports